<template>
  <section class="section">
    <div class="container">
      <h1 class="title">{{ $translate(materialtext) | capitalize }}</h1>
      <div class="level">
        <div class="level-left"></div>
        <div class="level-right">
          <b-field>
            <b-input
              :placeholder="$translate('search').concat('...') | capitalize"
              type="search"
              icon="magnify"
              v-model="searchname"
              @input="searchData()"
            ></b-input>
          </b-field>
        </div>
      </div>
      <b-table
        :data="filteredData"
        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :pagination-position="paginationPosition"
        :default-sort-direction="defaultSortDirection"
        :sort-icon="sortIcon"
        :sort-icon-size="sortIconSize"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        checkable
        :checked-rows.sync="checkedRows"
        @check="checkMaterial($event)"
        detailed
        :is-row-checkable="row => !permissionDenied"
        :default-sort="[sortField, sortOrder]"
        backend-sorting
        @sort="sortPressed"
      >
        <template slot-scope="props">
          <b-table-column field="CUI" :label="$translate('CUI') | capitalize" sortable>
            {{ props.row.CUI }}
          </b-table-column>
          <b-table-column field="commercial_name" :label="$translate('commercial_name') | capitalize" sortable>
            {{ $translateMaterial(props.row) }}
          </b-table-column>
          <b-table-column field="thickness" :label="$translate('thickness') | capitalize">
            {{ props.row.thickness }}
          </b-table-column>
          <b-table-column field="hardness" :label="$translate('hardness') | capitalize">
            {{ props.row.hardness }}
          </b-table-column>
          <b-table-column field="optional_tag" :label="$translate('optional_tag') | capitalize">
            <template v-for="item in props.row.optional_tag">
              {{ item.key }}
            </template></b-table-column
          >
        </template>
        <template slot="detail" slot-scope="props">
          <article class="media" v-for="variant in props.row.variants" v-bind:key="variant.id">
            <figure class="media-left">
              <p class="image">
                <img v-bind:src="variant.image" />
              </p>
            </figure>
            <div v-if="hasVariants" class="media-content">
              <div class="content">
                <p>
                  <strong>{{ $translateMaterialVariant(variant) }}</strong
                  ><br />
                  {{ variant.id }} - {{ variant.CUIV }}
                  <br />
                  CUI:
                  <template v-if="variant.CUI_optionalbool">{{ variant.CUI_optional }}</template
                  ><template v-else>{{ props.row.CUI }}</template>
                </p>
                <b-checkbox
                  v-if="tempcatalog[props.row.id]"
                  v-model="tempcatalog[props.row.id][variant.id]"
                  :native-value="variant.id"
                  @input="checkVariant(tempcatalog[props.row.id][variant.id], props.row.id, variant.id)"
                  >{{ $translate('variant') | capitalize }}</b-checkbox
                >
              </div>
            </div>
          </article>
        </template>
      </b-table>
    </div>
  </section>
</template>

<script>
import materialTools from '../../../helpers/mixins/materialTools'

export default {
  name: 'GeneralTableMaterial',
  mixins: [materialTools],
  props: ['materialtext', 'catalog', 'catalogmodels', 'realmodelcatalog', 'permissionDenied', 'module'],
  data() {
    return {
      searchname: null,
      tableData: [],
      filteredData: [],
      checkedRows: [],
      loading: true,
      page: 1,
      total: 0,
      queryString: '',

      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      defaultSortDirection: 'asc',
      sortIcon: 'arrow-up',
      sortIconSize: 'is-small',
      currentPage: 1,
      perPage: 10,

      tempcatalog: {},

      sortField: 'commercial_name',
      sortOrder: 'asc',

      hasVariants: true,
    }
  },
  computed: {
    config() {
      return this.$moduleConfiguration[this.module]
    },
  },
  watch: {
    catalog: function() {
      this.updateAfterload()
    },
  },
  created() {
    const moduleMaterialsWithoutVariants = this.config.materials.noVariants
    this.hasVariants = !moduleMaterialsWithoutVariants.includes(this.materialtext)
  },
  mounted() {
    this.loadAsyncData()
    this.tempcatalog = {}
  },
  methods: {
    sortPressed(field, order) {
      this.sortField = field
      this.sortOrder = order
      if (this.sortField == 'commercial_name') {
        this.filteredData.sort((a, b) => this.compareCommercialName(a, b))
      } else {
        this.filteredData.sort((a, b) => this.compareField(a, b))
      }
      if (this.sortOrder == 'desc') {
        this.filteredData.reverse()
      }
    },
    checkMaterial(rowchecks) {
      for (let index in this.tempcatalog) {
        let variableindex = index
        var temprow = rowchecks.find(temp => temp && temp.id === index)
        if (temprow === undefined) {
          let modelstoremove = []
          for (let modelid in this.catalogmodels) {
            let tempmodel = this.realmodelcatalog.find(temp => temp.id === modelid)
            if (tempmodel !== undefined) {
              if (this.materialtext === this.config.materials.Pel) {
                for (let i = 1; i <= this.config.maxPel; i++) {
                  if (tempmodel[`pell${i}mat`] === index) {
                    modelstoremove.push(tempmodel)
                  }
                }
              }
              if (this.materialtext === this.config.materials.Rip) {
                for (let i = 1; i <= this.config.maxPel; i++) {
                  if (tempmodel[`rip${i}mat`] === index) {
                    modelstoremove.push(tempmodel)
                  }
                }
              }
              if (this.materialtext === this.config.materials.Acc && this.module === 'tailored') {
                if (tempmodel.fodantmat === index || tempmodel.fodposmat === index) {
                  modelstoremove.push(tempmodel)
                }
              }
              if (tempmodel.treads) {
                tempmodel.treads.forEach(tread => {
                  if (tread === index) {
                    modelstoremove.push(tempmodel)
                  }
                })
              }
              if (tempmodel.fogge) {
                tempmodel.fogge.forEach(foggia => {
                  if (foggia === index) {
                    modelstoremove.push(tempmodel)
                  }
                })
              }
              if (tempmodel.bottomColors) {
                tempmodel.bottomColors.forEach(color => {
                  if (color === index) {
                    modelstoremove.push(tempmodel)
                  }
                })
              }
              if (this.materialtext === this.config.materials.Acc && this.module === 'fits') {
                tempmodel.fodmat.forEach(fodera => {
                  if (fodera.material === index) {
                    modelstoremove.push(tempmodel)
                  }
                })
              }
              if (this.materialtext === this.config.materials.All && this.module === 'fits') {
                tempmodel.allacci.forEach(allacciatura => {
                  if (allacciatura === index) {
                    modelstoremove.push(tempmodel)
                  }
                })
              }

              if (this.materialtext === this.config.materials.Pun && this.module === 'tailored') {
                if (tempmodel.battmat === index) {
                  modelstoremove.push(tempmodel)
                }
              }
              if (this.materialtext === this.config.materials.Mor) {
                if (tempmodel.intemat === index || tempmodel.tacczepp === index) {
                  modelstoremove.push(tempmodel)
                }
              }
              if (this.materialtext === this.config.materials.Mat) {
                if (tempmodel.guardmat === index) {
                  modelstoremove.push(tempmodel)
                }
              }
              if (this.materialtext === this.config.materials.Sug) {
                if (tempmodel.fascmat === index) {
                  modelstoremove.push(tempmodel)
                }
              }
              if (this.materialtext === this.config.materials.PaS) {
                if (tempmodel.contrmat === index) {
                  modelstoremove.push(tempmodel)
                }
              }
              if (this.materialtext === this.config.materials.Pat) {
                if (tempmodel.sottmat === index) {
                  modelstoremove.push(tempmodel)
                }
              }
              if (this.materialtext === this.config.materials.Mez) {
                if (tempmodel.punmat === index) {
                  modelstoremove.push(tempmodel)
                }
              }
            } else {
              //console.log("erroraccio brutto brutto");
            }
          }
          if (modelstoremove.length > 0) {
            let message = ''
            for (let i = 0; i < modelstoremove.length; i++) {
              message += modelstoremove[i].name + ', '
            }
            message = message.substring(0, message.length - 2)

            this.$buefy.dialog.confirm({
              title: this.$translate('attention'),
              message: this.$translate('elimination_variant_dialog') + message,
              cancelText: this.$translate('n'),
              confirmText: this.$translate('y'),
              onCancel: () => {
                //console.log(variableindex);
                let reinsertmaterial = this.tableData.find(temp => temp.id == variableindex)
                //console.log(reinsertmaterial);

                if (reinsertmaterial != undefined) {
                  rowchecks.push(reinsertmaterial)
                }
                this.$emit('update:catalog', this.tempcatalog)
                this.$emit('updateModelCatalog')
                this.$forceUpdate()
              },
              onConfirm: () => {
                for (let modeltoremoveindex in modelstoremove) {
                  delete this.catalogmodels[modelstoremove[modeltoremoveindex].id]
                }

                delete this.tempcatalog[variableindex]
                this.$emit('update:catalog', this.tempcatalog)
                this.$emit('updateModelCatalog')
                this.$forceUpdate()
              },
            })
          } else {
            delete this.tempcatalog[index]
          }
        }
      }
      for (let index in rowchecks) {
        if (this.tempcatalog[rowchecks[index].id] === undefined || this.tempcatalog[rowchecks[index].id].length === 0) {
          this.tempcatalog[rowchecks[index].id] = {}
          for (let indexvar in rowchecks[index].variants) {
            this.tempcatalog[rowchecks[index].id][rowchecks[index].variants[indexvar].id] = true
          }
        }
      }
      this.$emit('update:catalog', this.tempcatalog)
      this.$forceUpdate()
    },
    updateAfterload() {
      this.checkedRows = []
      this.tempcatalog = this.catalog
      if (Object.keys(this.tempcatalog).length !== 0) {
        for (let temptoadd in this.tempcatalog) {
          const material = this.tableData.find(temp => temp.id === temptoadd)
          if (material) {
            this.checkedRows.push(material)
          }
        }
      }
    },
    checkVariant(checkbool, materialid, variantid) {
      if (checkbool) {
        this.tempcatalog[materialid][variantid] = true
      } else {
        let modelstoremove = []
        for (let modelid in this.catalogmodels) {
          let tempmodel = this.realmodelcatalog.find(temp => temp.id === modelid)
          if (tempmodel !== undefined && this.hasVariants) {
            if (this.materialtext === this.config.materials.Pel) {
              for (let i = 1; i <= this.config.maxPel; i++) {
                if (tempmodel[`pell${i}mat`] === materialid && tempmodel[`pell${i}var`] === variantid) {
                  modelstoremove.push(tempmodel)
                }
              }
            }
            if (this.materialtext === this.config.materials.Rip) {
              for (let i = 1; i <= this.config.maxPel; i++) {
                if (tempmodel[`rip${i}mat`] === materialid && tempmodel[`rip${i}var` === variantid]) {
                  modelstoremove.push(tempmodel)
                }
              }
            }
            if (this.module === 'fits') {
              if (this.materialtext === this.config.materials.Acc) {
                tempmodel.fodmat.forEach(fodera => {
                  if (fodera.material === materialid && fodera.variant === variantid) {
                    modelstoremove.push(tempmodel)
                  }
                })
              }
            }
            if (this.module === 'tailored') {
              if (this.materialtext === this.config.materials.Acc) {
                if (
                  (tempmodel.fodantmat === materialid && tempmodel.fodantvar === variantid) ||
                  (tempmodel.fodposmat === materialid && tempmodel.fodposvar === variantid)
                ) {
                  modelstoremove.push(tempmodel)
                }
              }
            }
            if (this.materialtext === this.config.materials.Pun) {
              if (tempmodel.battmat === materialid && tempmodel.battvar === variantid) {
                modelstoremove.push(tempmodel)
              }
            }
            if (this.materialtext === this.config.materials.Mor) {
              if (
                (tempmodel.intemat === materialid && tempmodel.intevar === variantid) ||
                (tempmodel.tacczepp === materialid && tempmodel.tacczeppvar === variantid)
              ) {
                modelstoremove.push(tempmodel)
              }
            }
            if (this.materialtext === this.config.materials.Mat) {
              if (tempmodel.guardmat === materialid && tempmodel.guardvar === variantid) {
                modelstoremove.push(tempmodel)
              }
            }
            if (this.materialtext === this.config.materials.Sug) {
              if (tempmodel.fascmat === materialid && tempmodel.fascvar === variantid) {
                modelstoremove.push(tempmodel)
              }
            }
            if (this.materialtext === this.config.materials.PaS) {
              if (tempmodel.contrmat === materialid && tempmodel.contrvar === variantid) {
                modelstoremove.push(tempmodel)
              }
            }
            if (this.materialtext === this.config.materials.Pat) {
              if (tempmodel.sottmat === materialid && tempmodel.sottvar === variantid) {
                modelstoremove.push(tempmodel)
              }
            }
            if (this.materialtext === this.config.materials.Mez) {
              if (tempmodel.punmat === materialid && tempmodel.punvar === variantid) {
                modelstoremove.push(tempmodel)
              }
            }
          } else {
            //console.log("erroraccio brutto brutto");
          }
        }
        if (modelstoremove.length > 0) {
          let message = ''
          for (let i = 0; i < modelstoremove.length; i++) {
            message += modelstoremove[i].name + ', '
          }
          message = message.substring(0, message.length - 2)

          let tempmaterialid = materialid

          this.$buefy.dialog.confirm({
            title: this.$translate('attention'),
            message: this.$translate('elimination_variant_dialog') + message,
            cancelText: this.$translate('n'),
            confirmText: this.$translate('y'),
            onCancel: () => {
              //console.log(tempmaterialid);
              this.tempcatalog[tempmaterialid][variantid] = true
              this.$forceUpdate()
              this.$emit('update:catalog', this.tempcatalog)
            },
            onConfirm: () => {
              this.tempcatalog[tempmaterialid][variantid] = false
              delete this.tempcatalog[tempmaterialid][variantid]

              if (Object.keys(this.tempcatalog[tempmaterialid]).length === 0) {
                delete this.tempcatalog[tempmaterialid]
                let rowtoremove = this.checkedRows.find(temp => temp.id === tempmaterialid)
                this.checkedRows.splice(this.checkedRows.indexOf(rowtoremove), 1)
              }

              for (let modeltoremoveindex in modelstoremove) {
                delete this.catalogmodels[modelstoremove[modeltoremoveindex].id]
              }
              this.$emit('update:catalog', this.tempcatalog)
              this.$emit('updateModelCatalog')
              this.$forceUpdate()
            },
          })
        } else {
          //console.log(materialid);
          //console.log(variantid);

          delete this.tempcatalog[materialid][variantid]

          if (Object.keys(this.tempcatalog[materialid]).length === 0) {
            delete this.tempcatalog[materialid]
            let rowtoremove = this.checkedRows.find(temp => temp.id == materialid)
            this.checkedRows.splice(this.checkedRows.indexOf(rowtoremove), 1)
          }
        }
      }
      this.$forceUpdate()
      this.$emit('update:catalog', this.tempcatalog)
    },
    searchData() {
      this.filteredData = []
      this.tableData.forEach(material => {
        if (
          this.searchname == null ||
          this.$translateMaterial(material)
            .toLowerCase()
            .includes(this.searchname.toLowerCase()) ||
          material.CUI.toLowerCase().includes(this.searchname.toLowerCase()) ||
          material.optional_tag
            .map(e => e.key)
            .join(' ')
            .toLowerCase()
            .includes(this.searchname.toLowerCase())
        ) {
          this.filteredData.push(material)
        }
      })
    },

    loadAsyncData() {
      this.loading = true
      this.tableData = []
      this.getMaterialArray(this.materialtext)
        .then(arrayresponse => {
          this.tableData = arrayresponse
          this.filteredData = this.tableData
          this.loading = false

          this.sortPressed('commercial_name', 'asc')
        })
        .catch((this.tableData = []))
    },
  },
}
</script>

<style scoped>
.container >>> p.image img {
  height: auto;
  width: 100px;
}
.container >>> thead th:nth-child(9),
.container >>> thead th:nth-child(10),
.container >>> thead th:nth-child(11),
.container >>> thead th:nth-child(12),
.container >>> thead th:nth-child(13) {
  display: none;
}
</style>
